import { useQuery } from '@tanstack/react-query';

import {
  MetaDataApiMetaDataPositionPositionIdShifttypeGetRequest,
  SchedulerMetaCacheKeys,
  useApi,
} from '../index';

export const useShiftTypesByPositionIdGet = (
  body: MetaDataApiMetaDataPositionPositionIdShifttypeGetRequest
) => {
  const api = useApi();
  return useQuery({
    queryKey: [SchedulerMetaCacheKeys.ShiftTypes, body],
    queryFn: () => api.metaDataApi.metaDataPositionPositionIdShifttypeGet(body),
    retry: false,
    refetchOnWindowFocus: false,
    enabled: Boolean(body.positionId),
    refetchOnMount: false,
  });
};

export const usePeriodTypesMetaGet = () => {
  const api = useApi();
  return useQuery({
    queryKey: [SchedulerMetaCacheKeys.PeriodTypes],
    queryFn: () =>
      api.metaDataApi
        .metaDataPeriodtypeGet({})
        .then((response) => response?.data?.data ?? []),
    retry: false,
    refetchOnWindowFocus: false,
  });
};
